export var ObjectType;
(function (ObjectType) {
    ObjectType[ObjectType["New"] = 0] = "New";
    ObjectType[ObjectType["Active"] = 1] = "Active";
    ObjectType[ObjectType["Finished"] = 2] = "Finished";
})(ObjectType || (ObjectType = {}));
export var AuctionStatus;
(function (AuctionStatus) {
    AuctionStatus[AuctionStatus["New"] = 1] = "New";
    AuctionStatus[AuctionStatus["Active"] = 4] = "Active";
    AuctionStatus[AuctionStatus["Aftersale"] = 5] = "Aftersale";
    AuctionStatus[AuctionStatus["Finished"] = 9] = "Finished";
})(AuctionStatus || (AuctionStatus = {}));
export var AuctionItemStatus;
(function (AuctionItemStatus) {
    AuctionItemStatus[AuctionItemStatus["Draft"] = 1] = "Draft";
    AuctionItemStatus[AuctionItemStatus["Prepared"] = 2] = "Prepared";
    AuctionItemStatus[AuctionItemStatus["Scheduled"] = 3] = "Scheduled";
    AuctionItemStatus[AuctionItemStatus["Available"] = 4] = "Available";
    AuctionItemStatus[AuctionItemStatus["Sold"] = 5] = "Sold";
    AuctionItemStatus[AuctionItemStatus["NotSold"] = 6] = "NotSold";
    AuctionItemStatus[AuctionItemStatus["SoldConfirmed"] = 7] = "SoldConfirmed";
    AuctionItemStatus[AuctionItemStatus["Magic8"] = 8] = "Magic8";
    AuctionItemStatus[AuctionItemStatus["Completed"] = 9] = "Completed";
})(AuctionItemStatus || (AuctionItemStatus = {}));
